import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Link } from 'react-router-dom';

// import './loans.css';


const TaskInGrid = ( { task } ) => {
    const [ show, setShow ] = useState( false );
    const [ hasTask, setHasTask ] = useState( false );
    const [ title, setTitle ] = useState( '' );
    const [ details, setDetails ] = useState( '' );

    const handleOnMouseEnter = () => {
        setShow( true );
    }
    const handleOnMouseLeave = () => {
        setShow( false );
    }

    const ref = useRef();

    const popup = (
        <Popover id="popover-basic" className='tf-multi-lead-badge-container' onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>
            <Popover.Header as="h3">{title}</Popover.Header>
            <Popover.Body style={ { maxHeight: '250px', overflowY: 'auto' } }>
                <div dangerouslySetInnerHTML={ { __html: details } }></div>
            </Popover.Body>
        </Popover>
    );

    useEffect( () => {
        if ( task ) {
            setTitle( task.name );
            setDetails( task.outcome ? task.outcome : task.details );
            setHasTask( true );
        }
    }, [ task ] );

    return (
        <Container>
            <Row className='p-0'>
                {
                    hasTask ? (
                        <OverlayTrigger placement="left" overlay={popup} show={show} container={document.body}>
                            <Col xs='auto' className='ps-1 pe-1 align-items-center' ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={handleOnMouseLeave}>{title}</Col>
                        </OverlayTrigger>
                    ) : (
                        null
                    )
                }
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TaskInGrid );